var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "screenshot-viewer-modal",
      "modal-class": "screenshot-viewer-modal",
      "centered": "",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hide": _vm.handleHide
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "screenshot-viewer-header text-center"
        }, [_c('h4', [_vm._v("Screenshot Viewer")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.internalShow,
      callback: function callback($$v) {
        _vm.internalShow = $$v;
      },
      expression: "internalShow"
    }
  }, [_c('b-container', [_c('div', {
    staticClass: "screenshot-chips d-flex flex-wrap mb-3 gap-2"
  }, _vm._l(_vm.screenshots, function (screenshot, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "screenshot-chip",
      class: {
        active: _vm.activeScreenshot === index
      },
      attrs: {
        "pill": "",
        "variant": "light"
      },
      on: {
        "click": function click($event) {
          _vm.activeScreenshot = index;
        }
      }
    }, [_vm._v(" " + _vm._s(screenshot.name || "Screenshot ".concat(index + 1)) + " ")]);
  }), 1), _c('div', {
    staticClass: "screenshot-display text-center",
    on: {
      "click": _vm.toggleZoom
    }
  }, [_vm.screenshots.length > 0 ? _c('img', {
    staticClass: "screenshot-img",
    attrs: {
      "src": _vm.screenshots[_vm.activeScreenshot].url,
      "alt": _vm.screenshots[_vm.activeScreenshot].name
    }
  }) : _c('p', {
    staticClass: "text-muted text-center mt-4"
  }, [_vm._v(" No screenshots available for this enrollment. ")])]), _vm.isZoomed ? _c('div', {
    staticClass: "zoom-overlay",
    on: {
      "click": _vm.toggleZoom
    }
  }, [_c('img', {
    staticClass: "zoomed-img",
    attrs: {
      "src": _vm.screenshots[_vm.activeScreenshot].url,
      "alt": _vm.screenshots[_vm.activeScreenshot].name
    }
  })]) : _vm._e(), _vm.screenshots.length > 1 ? _c('div', {
    staticClass: "screenshot-action-btns"
  }, [_c('b-button', {
    staticClass: "screenshot-action-btn btn",
    attrs: {
      "disabled": _vm.activeScreenshot === 0
    },
    on: {
      "click": _vm.prevScreenshot
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left mr-2"
  }), _vm._v(" Previous ")]), _c('span', {
    staticClass: "text-muted screenshot-pagination"
  }, [_vm._v(" " + _vm._s(_vm.activeScreenshot + 1) + " of " + _vm._s(_vm.screenshots.length) + " ")]), _c('b-button', {
    staticClass: "screenshot-action-btn btn btn-primary",
    attrs: {
      "disabled": _vm.activeScreenshot === _vm.screenshots.length - 1
    },
    on: {
      "click": _vm.nextScreenshot
    }
  }, [_vm._v(" Next "), _c('i', {
    staticClass: "fas fa-chevron-right ml-2"
  })])], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }